<template>
  <el-dialog
    v-if="dialogVisible"
    class="expansion-initiate-tx-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="通道名称" prop="chanName">
        <el-input v-model="dataForm.chanName" disabled></el-input>
      </el-form-item>

      <el-form-item label="金额" prop="balance">
        <el-input v-model="dataForm.balance"></el-input>
      </el-form-item>

      <el-form-item label="目标用户" prop="toUserId">
        <el-select v-model="dataForm.toUserId" placeholder="请选择指定用户">
          <el-option
            v-for="item in userList"
            :key="item.userId"
            :label="item.userName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleCreateChan()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'InitiateTx',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  props: {
    userId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      title: '发起交易',
      position: 'right',
      dataForm: {
        chanName: '', //通道名称
        balance: null
      },
      editRule: {
        chanName: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '只能输入英文和数字', trigger: 'blur' }
        ],
        balance: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ]
      },
      userList: [],
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {},
  methods: {
    //发起交易
    handleCreateChan() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          this.disabled = true
          //获取form数据
          this.dataForm.fromUserId = this.userId
          this.dataForm.toUserId = this.dataForm.toUserId
          this.dataForm.chanName = this.dataForm.chanName
          this.dataForm.balance = Number(this.dataForm.balance)
          this.$apis.expansionDemo
            .initiateTx(this.dataForm)
            .then(res => {
              if (res) {
                this.$message.success('交易成功成功')
                // this.dataForm.txId = res.data
                this.handleCancel()
                this.$emit('initiateTxSuccess')
              }
              this.disabled = false
            })
            .catch(err => {
              this.disabled = false
            })
        } else {
          this.$message.warning('请完善信息')
          this.disabled = false
          return
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
      this.$refs.dataForm.resetFields()
    },
    getChan() {
      let params = {}
      params.userId = this.userId
      this.$apis.expansionDemo
        .getChan(params)
        .then(res => {
          if (res) {
            // this.dataForm.chanName = res.data.chanName
            this.getChanUser()
          }
          this.disabled = false
        })
        .catch(err => {
          this.disabled = false
        })
    },
    getChanUser() {
      let params = {}
      params.chanName = this.dataForm.chanName
      this.$apis.expansionDemo
        .getChanUser(params)
        .then(res => {
          if (res) {
            this.userList = []
            res.data.map((item, index) => {
              if (item.userId != this.userId) {
                this.userList.push(item)
              }
            })
          }
          this.disabled = false
          console.log(this.userList)
        })
        .catch(err => {
          this.disabled = false
        })
    },
    handleOpen(data) {
      this.dataForm = {
        chanName: data,
        balance: null,
        userId: null
      }

      this.getChanUser()
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.expansion-initiate-tx-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    /deep/ .el-form-item__content {
      display: flex;
    }
  }
}
</style>
